import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";

export const ActionIcon = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box
            sx={{
                marginRight:2,
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                color: props.color ? props.color : colors.txt["secondary"],
                "& svg" : {
                    width:20,
                },
                "& *" : {
                    fill: props.color ? props.color : colors.txt["secondary"],
                }
            }}
        >
            {props.children}
        </Box>
    );

}